module.exports = __webpack_public_path__ + "img/desescalada3.100c9c95.gif";